import React from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';
import {has, join, map, sortBy} from 'lodash/fp';
import {isArray, toUpper} from 'lodash';

import {IconCheckmark} from '@appComponents/IconCollection';
import Chip from '@ui/Chip';

export const columnObjectAlignCenter = {
    header: {
        align: 'center',
    },
    content: {
        align: 'center',
    },
};

export const columnObjectAlignLeft = {
    header: {
        align: 'left',
    },
    content: {
        align: 'left',
    },
};

export const columnObjectAlignRight = {
    header: {
        align: 'right',
    },
    content: {
        align: 'right',
    },
};

export const renderNameOfRowColumn = (row, column) => (
    (!row || undefined === row[column] || null === row[column])
        ? ''
        : row[column].name || ''
);

export const renderProductColumnForComputerVision = (productName, isComputerVision) => (
    <>
        {productName}
        {isComputerVision
            ? (
                <Popup
                    content='Computer Vision'
                    position='top center'
                    trigger={<Chip size='small' label='CV' className='td__label' />}
                />
            )
            : null
        }
    </>
);

export const getDisabledClassNameForCell = (tableRowData) => {
    return tableRowData.disabled || tableRowData.is_disabled ? '--is-disabled' : null;
};

export const renderCheckbox = (value) => {
    return value ? <IconCheckmark/> : '';
};

export const hasClients = (row) => {
    if (true === has('clients', row)) {
        return true === isArray(row.clients) && 0 < row.clients.length;
    }

    return false;
};

export const namesOfClients = (clients, prop = 'name', separator = ', ') => {
    return join(separator, map(prop, sortBy(client => toUpper(client.name), clients)));
};

export const TunnelStatus = ({isStarted}) => (
    <Chip
        size='small'
        color={isStarted ? 'success' : 'error'}
        label={isStarted ? 'Started' : 'Stopped'}
    />
);

TunnelStatus.propTypes = {
    isStarted: PropTypes.bool.isRequired,
};

export const getArgosJobStatusChipColor = (statusLower) => {
    if ('running' === statusLower) {
        return 'success';
    }

    if ('terminated' === statusLower || 'failed' === statusLower || 'error' === statusLower) {
        return 'error';
    }

    if ('initializing_infrastructure' === statusLower || 'initializing_pipeline' === statusLower) {
        return 'warning';
    }

    return 'default';
};

export const getArgosStreamStatusChipColor = (statusLower) => {
    if ('processing' === statusLower) {
        return 'success';
    }

    if ('cancelled' === statusLower || 'failed' === statusLower || 'error' === statusLower) {
        return 'error';
    }

    return 'default';
};

export const formatArgosStatusLabel = (label) => {
    if (null == label || '' === label) {
        return label;
    }

    const text = String(label).toLowerCase();

    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const ArgosStatus = ({label, color}) => (
    <Chip
        size='small'
        color={color}
        className='argos-status-label'
        label={formatArgosStatusLabel(label)}
    />
);

ArgosStatus.propTypes = {
    label: PropTypes.string,
    color: PropTypes.string,
};

export const renderDescription = (description, color, externalDescription) => {
    if (!description) {
        return;
    }

    const chip = (
        <Chip
            size='small'
            label={description}
            sx={{
                bgcolor: color ? `#${color}` : '#ece9e9',
                fontWeight: 500,
                height: 'auto',
            }}
        />
    );

    return externalDescription
        ? <Popup content={`External description: ${externalDescription}`} trigger={chip} />
        : chip;
};
